import { HeatingModeEnum } from "../components/recipeCreation/utils/constants";
import { approxTimeHandlerFunction } from "../components/recipeCreation/utils/getTime";

const cookingTimeCalculation = (substeps: any) => {
    return substeps?.reduce((totalTime: any, nextSubStep: any) => {
        if (nextSubStep?.type === "instruction") {
            const { parameters } = nextSubStep;
            let tatFlag = true;
            const total = parameters.settings.reduce((prev: number, setting: any) => {
                if ([HeatingModeEnum.TAT, HeatingModeEnum.RICECOOKER].includes(setting.heatingMode) && parseInt(setting.temperature, 10) > 20 && tatFlag) {
                    tatFlag = false;
                    return prev + approxTimeHandlerFunction(setting);
                }
                return prev + setting.time;
            }, 0)
            return (total + totalTime)
        }
        return totalTime
    }, 0);
}

export default cookingTimeCalculation;